import { FlavourServiceService } from 'cms-typescript-sdk/unistack/services/flavour-service.service';
import { PagedDataProvider } from '@shared/models/data-provider.model';
import { UnistackFlavourListRsp } from 'cms-typescript-sdk/unistack/models/unistack-flavour-list-rsp';

export class TariffsDataProvider extends PagedDataProvider<UnistackFlavourListRsp> {

  constructor(private tariffService: FlavourServiceService) {
    super();
  }

  public loadData() {
    return this.tariffService.FlavourList(
      {
        metaLimit: String(this.page.pageSize),
        metaOffset: String(this.page.currentIndex)
      }
    );
  }

}
